module.exports = __webpack_public_path__ + "static/hip-flash-new-2-6694d8ffff5d6c57b9b9e8454df36dab.jpg";